import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { toast } from "sonner";
import { get, patch } from "@/lib/api";
import { BOOKING_STATUS, formatDate } from "@/lib/data";

const STATUSES = ["confirmed", "attended", "no_show", "cancelled"];

export default function Bookings() {
  const qc = useQueryClient();
  const [filter, setFilter] = useState("all");
  const { data: bookings = [] } = useQuery({ queryKey: ["partner-bookings"], queryFn: () => get("/partner/bookings") });

  const mut = useMutation({
    mutationFn: ({ id, status }) => patch(`/partner/bookings/${id}`, { status }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["partner-bookings"] });
      qc.invalidateQueries({ queryKey: ["partner-dashboard"] });
      toast.success("Durum güncellendi");
    },
  });

  const filtered = filter === "all" ? bookings : bookings.filter((b) => b.status === filter);

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Rezervasyonlar</h1>
      <p className="text-sm text-[#64748B]">Müşteri rezervasyonlarını yönetin</p>

      <div className="mt-5 flex flex-wrap gap-2">
        <button data-testid="booking-filter-all" onClick={() => setFilter("all")} className={`rounded-md border px-3 py-1.5 text-sm ${filter === "all" ? "border-[#2D2926] bg-[#2D2926] text-white" : "border-[#E2E8F0] bg-white text-[#475569]"}`}>Tümü ({bookings.length})</button>
        {STATUSES.map((s) => (
          <button key={s} data-testid={`booking-filter-${s}`} onClick={() => setFilter(s)} className={`rounded-md border px-3 py-1.5 text-sm ${filter === s ? "border-[#2D2926] bg-[#2D2926] text-white" : "border-[#E2E8F0] bg-white text-[#475569]"}`}>{BOOKING_STATUS[s].label}</button>
        ))}
      </div>

      <div className="mt-4 overflow-hidden rounded-md border border-[#E2E8F0] bg-white">
        <table className="w-full text-sm">
          <thead className="bg-[#F1F5F9] text-left text-xs uppercase tracking-wide text-[#64748B]">
            <tr>
              <th className="px-4 py-3">Müşteri</th>
              <th className="px-4 py-3">Seans</th>
              <th className="px-4 py-3">Tarih</th>
              <th className="px-4 py-3">Durum</th>
              <th className="px-4 py-3">Aksiyon</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#F1F5F9]">
            {filtered.length === 0 && <tr><td colSpan={5} className="px-4 py-8 text-center text-[#64748B]">Kayıt yok.</td></tr>}
            {filtered.map((b) => {
              const st = BOOKING_STATUS[b.status];
              return (
                <tr key={b.id} data-testid={`partner-booking-${b.id}`} className="hover:bg-[#F7F9FA]">
                  <td className="px-4 py-3 font-medium">{b.user_name}</td>
                  <td className="px-4 py-3 text-[#475569]">{b.session_title}</td>
                  <td className="px-4 py-3 text-[#475569]">{formatDate(b.date)} · {b.start_time}</td>
                  <td className="px-4 py-3"><span className={`rounded border px-2 py-0.5 text-xs font-medium ${st.color}`}>{st.label}</span></td>
                  <td className="px-4 py-3">
                    <select
                      data-testid={`booking-status-select-${b.id}`}
                      value={b.status}
                      onChange={(e) => mut.mutate({ id: b.id, status: e.target.value })}
                      className="rounded-md border border-[#E2E8F0] bg-white px-2 py-1 text-xs outline-none focus:border-[#2D2926]"
                    >
                      {STATUSES.map((s) => <option key={s} value={s}>{BOOKING_STATUS[s].label}</option>)}
                    </select>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
